import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section data-section-id="167116" id="page-intro" className="relative flex min-h-screen w-full flex-col overflow-hidden bg-background lg:min-h-[800px] lg:flex-row">
      <h1 className="sr-only">Conditions We Treat</h1>
      {}
      <div className="z-10 flex w-full flex-col justify-center px-6 py-20 lg:w-[60%] lg:px-24 lg:py-32">
        <div className="max-w-2xl">
          <h2 className="font-serif text-[36px] lg:text-7xl font-medium uppercase leading-[1.1] tracking-tight text-primary">
            Conditions We Treat
          </h2>
          
          <h3 className="font-serif mt-6 text-[22px] lg:text-3xl font-medium leading-[1.3] text-accent">
            Expert care for your body, tailored to your lifestyle in Limassol and Nicosia.
          </h3>
          
          <p className="font-sans mt-6 text-[18px] leading-[1.7] text-secondary">
            Our multi-disciplinary team uses a holistic approach to identify and treat the source of your discomfort, helping you return to the activities you love through precise chiropractic and acupuncture care.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <Button asChild className="h-auto rounded-lg border-none bg-accent px-[36px] py-[16px] font-sans font-semibold uppercase tracking-wider text-white shadow-lg transition-all hover:scale-105 hover:bg-accent/90">
              <Link to="/ContactPage">
                Book Your Consultation
              </Link>
            </Button>
            
            <Button asChild className="h-auto rounded-lg border border-accent bg-transparent px-[36px] py-[16px] font-sans font-semibold uppercase tracking-wider text-accent transition-all hover:bg-accent/5 hover:scale-105">
              <Link to="/TreatmentsPage">
                Explore Treatments
              </Link>
            </Button>
          </div>

          <p className="font-sans mt-8 text-[14px] text-secondary opacity-80">
            Questions about our specialized care?{" "}
            <Link to="/ContactPage" className="text-accent underline underline-offset-4 transition-colors hover:text-primary">
              Contact the Bodywerks team directly.
            </Link>
          </p>
        </div>
      </div>

      {}
      <div className="relative min-h-[400px] w-full lg:min-h-full lg:w-[40%]">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/athlete_nordic_curl_action.png)] bg-cover bg-center grayscale-[20%]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent lg:bg-gradient-to-r lg:from-background lg:via-background/60 lg:to-transparent" />
      </div>
    </section>;
}